import {HeaderNav} from './styled';

export default function Navbar() {
  return (
    <HeaderNav data-cy="navbar">
      <div>
        <span>Rule of Thumb</span>
      </div>
    </HeaderNav>
  );
}
